import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

const URL_MUNICIPIOS_IBGE = "https://servicodados.ibge.gov.br/api/v1/localidades/municipios?orderBy=nome";

// Cache em módulo para buscar a lista do IBGE apenas uma vez por sessão.
let municipiosCache = null;

const normalizar = (texto) =>
    texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const Titulo = styled.p`
    margin: 0 0 8px 0;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
`;
const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #94a3b8;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    &:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 1px #2563eb;
    }
`;
const Aviso = styled.p`
    margin: 10px 0 0 0;
    font-size: 12px;
    color: #64748b;
`;
const ListaSugestoes = styled.ul`
    list-style: none;
    margin: 10px 0 0 0;
    padding: 0;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
`;
const Sugestao = styled.li`
    padding: 10px 12px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
        border-bottom: 1px solid #f1f5f9;
    }
    &:hover {
        background-color: #eff6ff;
    }
`;

const ModalCelulaMunicipio = ({ titulo, valor, onSave, onClose }) => {

    const [busca, setBusca] = useState(valor || "");
    const [municipios, setMunicipios] = useState(municipiosCache || []);
    const [carregando, setCarregando] = useState(!municipiosCache);
    const [erro, setErro] = useState(false);

    useEffect(() => {

        if (municipiosCache) return;

        const fetchMunicipios = async () => {
            try {
                const { data } = await axios.get(URL_MUNICIPIOS_IBGE);
                municipiosCache = data.map((m) => ({
                    nome: m.nome,
                    uf: m.microrregiao?.mesorregiao?.UF?.sigla
                        ?? m["regiao-imediata"]?.["regiao-intermediaria"]?.UF?.sigla
                        ?? ""
                }));
                setMunicipios(municipiosCache);
            } catch (err) {
                console.error(err);
                setErro(true);
            } finally {
                setCarregando(false);
            }
        };

        fetchMunicipios();

    }, []);

    const sugestoes = useMemo(() => {

        const termo = normalizar(busca.trim());
        if (termo.length < 3) return [];

        return municipios
            .filter((m) => normalizar(m.nome).includes(termo))
            .slice(0, 10);

    }, [busca, municipios]);

    const selecionar = (municipio) => {
        onSave({
            municipio: municipio.nome,
            estado: municipio.uf
        });
    };

    return (
        <Overlay state={true} changeContent={onClose}>
            <Modal header={true} close={onClose} size="sm">
                <Titulo>{titulo}</Titulo>
                <Input
                    autoFocus
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                    placeholder="Digite ao menos 3 letras..."
                />
                {carregando && <Aviso>CARREGANDO MUNICÍPIOS...</Aviso>}
                {erro && <Aviso>ERRO AO CARREGAR A LISTA DO IBGE.</Aviso>}
                {!carregando && busca.trim().length >= 3 && sugestoes.length === 0 && (
                    <Aviso>NENHUM MUNICÍPIO ENCONTRADO.</Aviso>
                )}
                {sugestoes.length > 0 && (
                    <ListaSugestoes>
                        {sugestoes.map((m) => (
                            <Sugestao
                                key={`${m.nome}-${m.uf}`}
                                onClick={() => selecionar(m)}
                            >
                                {m.nome} / {m.uf}
                            </Sugestao>
                        ))}
                    </ListaSugestoes>
                )}
            </Modal>
        </Overlay>
    )

}

export default ModalCelulaMunicipio;
